import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    setIsOffline({ commit }, isOffline = true) {
      let oldSettings = this.getters["entities/settings/query"]().first();
      if (oldSettings) {
        oldSettings.isOffline = isOffline;
        oldSettings.id = 1;
        this.dispatch("entities/settings/create", { data: oldSettings });
      }
    },
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last ? last : 0
      });
    },

    async updateSettings(context, settings) {
      const store = this;
      let oldSettings = store.getters["entities/settings/find"](settings.id);
      let newSettings = {};
      if (settings.calendarSettings) {
        newSettings.calendar = settings.calendarSettings;
      }
      if (settings.customerSettings) {
        newSettings.customer = settings.customerSettings;
      }
      if (settings.telecomSettings) {
        newSettings.telecom = settings.telecomSettings;
      }
      if (
        !(oldSettings.calendarSettings === settings.calendarSettings) ||
        oldSettings.isDirty === true
      ) {
        try {
          const accountId = store.getters["entities/accounts/query"]().first().id;
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/account-settings/${settings.id}`,
            data: {
              accountId: accountId,
              config: newSettings
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });

          store.dispatch("entities/settings/update", {
            where: response.data.id,
            data: {
              isDirty: false
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store }) {
  try {
    let response = await axios({
      method: "get",
      url: API_BASE_URL + `/account-settings`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });

    const obj = response.data.data;
    let results = obj && obj[0] ? obj[0].config : null;

    if (results) {
      let settings = {};
      if (results.calendar) {
        settings.calendar = {
          workDays: results.calendar.workDays,
          requiredAppointmentFields: results.calendar.requiredAppointmentFields
        };
      } else {
        settings.calendar = {};
      }
      if (results.customer) {
        settings.customer = {
          requiredNewCustomerFields: results.customer.requiredNewCustomerFields
        };
      } else {
        settings.customer = {};
      }
      if (results.telecom) {
        settings.telecom = results.telecom;
      } else {
        settings.telecom = {};
      }
      store.dispatch("entities/settings/update", {
        where: 1,
        data: {
          calendarSettings: settings.calendar,
          customerSettings: settings.customer,
          telecomSettings: settings.telecom
        }
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
  } catch (error) {
    console.error("settings hydrate: " + JSON.stringify(error));
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
